import classNames from 'classnames'

import { QA_NAME_TEXT_DEFAULT } from '../../constants/qa'
import { getQaSelector } from '../../utils/common'

import * as styles from './Text.module.css'

function Text({
  Element = 'span',
  children,
  className,
  disabled,
  done,
  isSecondary,
  qaName,
  ref,
  style,
  unread,
  onClick,
  ...restProps
}) {
  const textClassName = classNames(
    styles.text,
    { [styles.secondary]: isSecondary },
    { [styles.unread]: unread },
    { [styles.disabled]: disabled },
    { [styles.done]: done },
    className
  )

  const qaProps = getQaSelector({
    context: QA_NAME_TEXT_DEFAULT,
    def: QA_NAME_TEXT_DEFAULT,
    value: qaName,
  })

  return (
    <Element
      {...restProps}
      {...qaProps}
      className={textClassName}
      ref={ref}
      style={style}
      onClick={onClick}
    >
      {children}
    </Element>
  )
}

export default Text
